var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarbudsWireless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 93,
    viewBox: "0 0 89 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1913 86.4343C10.1913 86.2741 4.85547 70.3985 3.04345 62.4396C1.23143 54.4808 0.0401033 44.7099 0.0401033 44.6198V44.4396C5.86249e-05 18.6908 18.6909 0 44.4396 0C56.2217 0.0132487 67.5173 4.69952 75.8485 13.0307C84.1797 21.3618 88.8659 32.6575 88.8792 44.4396C88.8705 48.0365 88.8222 51.8431 88.1648 55.3795C87.1637 59.7343 79.1391 85.3331 78.8388 86.4343L76.6055 85.7957C76.6756 85.5254 83.9937 58.7655 84.9448 54.5108C85.554 51.1879 85.8689 47.8178 85.8859 44.4396C85.8752 33.4515 81.5049 22.9167 73.7342 15.1479C65.9635 7.37912 55.4277 3.0113 44.4396 3.00335C20.0724 3.00335 3.04345 20.0223 3.00341 44.3495C3.13355 45.3506 4.28484 54.3606 6.00676 61.7889C7.79876 69.6577 12.4339 85.6155 12.474 85.8157L10.1913 86.4343Z",
    fill: "url(#paint0_radial_2144_1156)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9036 82.4413C11.7234 81.8807 7.44864 68.6059 5.75675 61.1576C4.06486 53.7093 2.89355 44.6191 2.89355 44.529V44.3488C2.89355 20.282 20.373 2.8125 44.4399 2.8125C55.4537 2.8231 66.0135 7.20232 73.8023 14.9893C81.5912 22.7763 85.973 33.335 85.9862 44.3488C85.976 47.7075 85.6611 51.0583 85.0452 54.36C84.1442 58.4245 77.8271 81.3902 77.5568 82.3913L74.6636 81.6004C74.7337 81.3601 81.2209 57.7237 82.1119 53.7293C82.6772 50.6341 82.9686 47.4952 82.9829 44.3488C82.9696 34.1316 78.9043 24.3367 71.6787 17.113C64.453 9.88924 54.6571 5.82645 44.4399 5.81585C21.7846 5.81585 5.8969 21.6135 5.8969 44.2587C6.01704 45.2598 7.09824 53.5891 8.67 60.4968C10.3319 67.815 14.6767 81.3901 14.7468 81.5203L11.9036 82.4413Z",
    fill: "url(#paint1_radial_2144_1156)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1794 6.32718C56.4757 3.93124 50.3348 2.75149 44.1493 2.86332C37.97 2.74022 31.8328 3.90629 26.1292 6.28713C15.1169 10.662 8.26854 21.4401 6.50732 26.4997C6.50732 26.4997 9.11023 26.7399 11.9434 23.7766C14.7765 20.8133 22.325 9.42063 44.1493 9.40061C65.9736 9.38058 73.5221 20.8834 76.3552 23.8267C79.1884 26.77 81.7913 26.5497 81.7913 26.5497C80.185 22.3054 73.1717 10.7021 62.1794 6.32718Z",
    fill: "url(#paint2_radial_2144_1156)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1962 56.1226L66.6287 92.1071C65.7879 91.8059 64.8542 91.6489 63.9614 91.6723C62.3096 91.6723 57.6243 90.9815 56.7934 88.9192C55.9625 86.8569 64.9625 57.4941 65.4731 55.4318C65.9837 53.3695 68.4764 52.5386 70.7089 53.4997C72.9414 54.4608 76.7757 55.7021 77.1962 56.1226Z",
    fill: "url(#paint3_radial_2144_1156)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1962 56.1226L66.6287 92.1071C65.7879 91.8059 64.8542 91.6489 63.9614 91.6723C62.3096 91.6723 57.6243 90.9815 56.7934 88.9192C55.9625 86.8569 64.9625 57.4941 65.4731 55.4318C65.9837 53.3695 68.4764 52.5386 70.7089 53.4997C72.9414 54.4608 76.7757 55.7021 77.1962 56.1226Z",
    fill: "url(#paint4_radial_2144_1156)",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1962 56.1226L66.6287 92.1071C65.7879 91.8059 64.8542 91.6489 63.9614 91.6723C62.3096 91.6723 57.6243 90.9815 56.7934 88.9192C55.9625 86.8569 64.9625 57.4941 65.4731 55.4318C65.9837 53.3695 68.4764 52.5386 70.7089 53.4997C72.9414 54.4608 76.7757 55.7021 77.1962 56.1226Z",
    fill: "url(#paint5_linear_2144_1156)",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1958 56.1221C78.5803 56.8205 79.8552 57.7177 80.98 58.785C82.0044 59.8375 82.7659 61.1169 83.2025 62.5192C83.3126 63.0398 76.0746 87.6072 75.8443 88.7985C75.6141 89.9898 72.841 91.5816 71.5595 92.1322C69.4171 93.1334 66.604 92.1322 66.604 92.1322L77.1958 56.1221Z",
    fill: "url(#paint6_linear_2144_1156)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1958 56.1221C78.5803 56.8205 79.8552 57.7177 80.98 58.785C82.0044 59.8375 82.7659 61.1169 83.2025 62.5192C83.3126 63.0398 76.0746 87.6072 75.8443 88.7985C75.6141 89.9898 72.841 91.5816 71.5595 92.1322C69.4171 93.1334 66.604 92.1322 66.604 92.1322L77.1958 56.1221Z",
    fill: "url(#paint7_linear_2144_1156)",
    fillOpacity: 0.16
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0133 56.1226L21.6251 92.0927C22.4659 91.7915 23.3553 91.6489 24.2481 91.6723C25.8999 91.6723 30.5851 90.9815 31.4161 88.9192C32.247 86.8569 23.247 57.4941 22.7364 55.4318C22.2258 53.3695 19.733 52.5386 17.5006 53.4997C15.2681 54.4608 11.4338 55.7021 11.0133 56.1226Z",
    fill: "url(#paint8_radial_2144_1156)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0133 56.1226L21.6251 92.0927C22.4659 91.7915 23.3553 91.6489 24.2481 91.6723C25.8999 91.6723 30.5851 90.9815 31.4161 88.9192C32.247 86.8569 23.247 57.4941 22.7364 55.4318C22.2258 53.3695 19.733 52.5386 17.5006 53.4997C15.2681 54.4608 11.4338 55.7021 11.0133 56.1226Z",
    fill: "url(#paint9_radial_2144_1156)",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0133 56.1226L21.6251 92.0927C22.4659 91.7915 23.3553 91.6489 24.2481 91.6723C25.8999 91.6723 30.5851 90.9815 31.4161 88.9192C32.247 86.8569 23.247 57.4941 22.7364 55.4318C22.2258 53.3695 19.733 52.5386 17.5006 53.4997C15.2681 54.4608 11.4338 55.7021 11.0133 56.1226Z",
    fill: "url(#paint10_linear_2144_1156)",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0136 56.1221C9.62917 56.8205 8.35428 57.7177 7.22941 58.785C6.20501 59.8375 5.44353 61.1169 5.00693 62.5192C4.8968 63.0398 12.1349 87.6072 12.3651 88.7985C12.5954 89.9898 15.3685 91.5816 16.6499 92.1322C18.7923 93.1334 21.729 92.1322 21.729 92.1322L11.0136 56.1221Z",
    fill: "url(#paint11_linear_2144_1156)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0136 56.1221C9.62917 56.8205 8.35428 57.7177 7.22941 58.785C6.20501 59.8375 5.44353 61.1169 5.00693 62.5192C4.8968 63.0398 12.1349 87.6072 12.3651 88.7985C12.5954 89.9898 15.3685 91.5816 16.6499 92.1322C18.7923 93.1334 21.729 92.1322 21.729 92.1322L11.0136 56.1221Z",
    fill: "url(#paint12_linear_2144_1156)",
    fillOpacity: 0.16
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2342 68.5566C84.2342 68.5566 88.8393 70.0683 86.2965 79.1184C83.7536 88.1685 78.8281 86.4266 78.8281 86.4266L84.2342 68.5566Z",
    fill: "url(#paint13_linear_2144_1156)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8303 68.5566C4.8303 68.5566 0.225163 70.0683 2.768 79.1184C5.31084 88.1685 10.2363 86.4266 10.2363 86.4266L4.8303 68.5566Z",
    fill: "url(#paint14_linear_2144_1156)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M81 86C82.0263 84.6137 83.3478 81.4989 84.3579 77.9885C85.2679 74.8212 85.8079 71.78 85.7796 70C85.8554 70.0598 85.9363 70.1269 86 70.184C85.9889 72.0017 85.452 74.9675 84.5683 78.04C83.5966 81.4216 82.3539 84.4352 81.3428 85.9172C81.2568 85.9393 81.1668 85.9623 81.1567 85.9623C81.1466 85.9623 81.0667 85.9862 81 86Z",
    fill: "url(#paint15_linear_2144_1156)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0.301758 47.0509V46.5495H3.38314L6.08246 46.0498L6.15439 46.5326L3.39603 47.0492L0.301758 47.0509Z",
    fill: "url(#paint16_linear_2144_1156)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00195 46.5577H1.37144L2.18511 46.5508L2.99976 46.5577L3.36925 46.5655L2.99976 46.5734L2.18511 46.5793L1.37144 46.5734L1.00195 46.5577Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M88.8389 47.0492V46.5495H85.6787L82.9794 46.0498L82.9536 46.5477L85.6658 47.0492H88.8389Z",
    fill: "url(#paint17_linear_2144_1156)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0596 46.5577H87.6901L86.8764 46.5508L86.0618 46.5577L85.6923 46.5655L86.0618 46.5734L86.8764 46.5793L87.6901 46.5734L88.0596 46.5577Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M8 86C6.9735 84.6137 5.6517 81.4989 4.64341 77.9885C3.73321 74.8212 3.19215 71.78 3.21946 70C3.14462 70.0598 3.0627 70.1269 3 70.184C3.01112 72.0017 3.54814 74.9675 4.43204 78.04C5.40898 81.4216 6.64482 84.4352 7.66222 85.9172C7.74919 85.9393 7.8392 85.9623 7.8483 85.9623C7.8574 85.9623 7.9373 85.9862 8 86Z",
    fill: "url(#paint18_linear_2144_1156)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.708 92.915L19.8045 92.9305L19.708 92.915Z",
    fill: "#212121"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2747 92.9982L20.0781 92.9697C20.1636 92.9864 20.2422 92.9982 20.2747 92.9982Z",
    fill: "#212121"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0749 92.9729L19.8076 92.9316C19.8823 92.9444 19.9835 92.9601 20.0759 92.9739L20.0749 92.9729Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M12.202 76.0911L12.1038 75.718C10.1895 68.8164 8.21135 61.6829 8.03545 58.1055L7.83203 58.2717C8.05707 61.9197 10.0097 68.9585 11.8994 75.7731L12.0026 76.1462C13.9581 83.2024 15.7299 89.3036 17.5056 92.3649L17.7729 92.4055C15.9775 89.4138 14.1851 83.2382 12.202 76.0911Z",
    fill: "url(#paint19_linear_2144_1156)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0864 58.3091L10.1359 58.2666L10.0864 58.3091Z",
    fill: "url(#paint20_linear_2144_1156)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4782 57.9863C10.4551 58.0037 10.4011 58.049 10.3403 58.0992L10.4782 57.9863Z",
    fill: "url(#paint21_linear_2144_1156)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M10.3401 58.1016L10.1367 58.2716L10.3401 58.1025V58.1016Z",
    fill: "url(#paint22_linear_2144_1156)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3401 58.1016L10.1367 58.2716L10.3401 58.1025V58.1016Z",
    fill: "url(#paint23_linear_2144_1156)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6253 92.915L69.5288 92.9305L69.6253 92.915Z",
    fill: "#212121"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0586 92.9982L69.2551 92.9697C69.1736 92.9864 69.095 92.9982 69.0586 92.9982Z",
    fill: "#212121"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2593 92.9729L69.5266 92.9316C69.4519 92.9444 69.3507 92.9601 69.2583 92.9739L69.2593 92.9729Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M76.2529 76.2104L76.3548 75.838C78.2444 68.951 80.197 61.8326 80.3706 58.2627L80.5705 58.4286C80.3483 62.0689 78.4219 69.0928 76.5566 75.893L76.4596 76.2653C74.5292 83.3067 72.7803 89.395 71.0275 92.4498L70.7637 92.4903C72.5291 89.505 74.2955 83.3424 76.2529 76.2104Z",
    fill: "url(#paint24_linear_2144_1156)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6895 58.3078L80.6406 58.2666C80.6703 58.2944 80.6895 58.3078 80.6895 58.3078Z",
    fill: "url(#paint25_linear_2144_1156)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M80.4404 58.1016L80.6429 58.2716L80.4404 58.1025V58.1016Z",
    fill: "url(#paint26_linear_2144_1156)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6824 92.915L70.5859 92.9305L70.6824 92.915Z",
    fill: "#212121"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1157 92.9982L70.3123 92.9697C70.2268 92.9864 70.1482 92.9982 70.1157 92.9982Z",
    fill: "#212121"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.313 92.9729L70.5803 92.9316C70.5056 92.9444 70.4044 92.9601 70.312 92.9739L70.313 92.9729Z",
    fill: "#212121"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2144_1156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.4396 43.2983) scale(44.4396 44.4396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948166,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960479,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985918,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99372,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2144_1156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.4399 42.6269) scale(41.5363 41.5363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123178,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478164,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.920046,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2144_1156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.0492 48.0533) rotate(-90) scale(44.0491 43.9175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694566,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864161,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958573,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2144_1156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.9677 72.5971) rotate(-74.1729) scale(18.7467 9.83552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51446,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2144_1156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5789 60.0673) rotate(106.26) scale(12.514 6.56551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452654,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2144_1156",
    x1: 61.0683,
    y1: 69.0774,
    x2: 68.0761,
    y2: 71.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2144_1156",
    x1: 76.5854,
    y1: 56.0624,
    x2: 87.5976,
    y2: 59.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2144_1156",
    x1: 76.5854,
    y1: 56.563,
    x2: 83.0926,
    y2: 58.5652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2144_1156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2418 72.5971) rotate(-105.827) scale(18.7467 9.83552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51446,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2144_1156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6306 60.0673) rotate(73.7398) scale(12.514 6.56551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452654,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2144_1156",
    x1: 27.1412,
    y1: 69.0774,
    x2: 20.1334,
    y2: 71.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2144_1156",
    x1: 11.6241,
    y1: 56.0624,
    x2: 0.611812,
    y2: 59.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2144_1156",
    x1: 11.6241,
    y1: 56.563,
    x2: 5.11684,
    y2: 58.5652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2144_1156",
    x1: 89.0993,
    y1: 70.0779,
    x2: 82.9451,
    y2: 86.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0780245,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376086,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2144_1156",
    x1: -0.0348941,
    y1: 70.0779,
    x2: 6.1193,
    y2: 86.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0780245,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376086,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2144_1156",
    x1: 83.4907,
    y1: 84.3876,
    x2: 77.4273,
    y2: 74.8936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2144_1156",
    x1: 0.301758,
    y1: 46.5495,
    x2: 6.10823,
    y2: 46.5495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2144_1156",
    x1: 88.7601,
    y1: 46.5495,
    x2: 82.9536,
    y2: 46.5495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2144_1156",
    x1: 5.25997,
    y1: 84.7527,
    x2: 11.3227,
    y2: 75.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2144_1156",
    x1: 13.18,
    y1: 87.4277,
    x2: 25.1621,
    y2: 76.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2144_1156",
    x1: 10.0904,
    y1: 58.32,
    x2: 10.3871,
    y2: 57.9155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2144_1156",
    x1: 10.1735,
    y1: 58.3644,
    x2: 10.4609,
    y2: 57.9728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2144_1156",
    x1: 10.6241,
    y1: 82.5455,
    x2: 22.8026,
    y2: 71.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2144_1156",
    x1: 10.1239,
    y1: 58.3443,
    x2: 10.4197,
    y2: 57.9404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2144_1156",
    x1: 75.5477,
    y1: 87.815,
    x2: 63.6038,
    y2: 77.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2144_1156",
    x1: 80.6847,
    y1: 58.3183,
    x2: 80.3973,
    y2: 57.9265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2144_1156",
    x1: 80.4194,
    y1: 82.845,
    x2: 68.2409,
    y2: 71.8792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarbudsWireless);
export default __webpack_public_path__ + "static/media/EarbudsWireless.a16439a8eea60712219b6ba0c6bd99bb.svg";
export { ForwardRef as ReactComponent };